import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  Autocomplete,
  Paper,
  InputAdornment,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  MenuItem
} from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import EventIcon from "@mui/icons-material/Event";
import theme from "../../../assets/theme";
import ArrowCircle_img from "../../../assets/image/Arrow_circle.png";
import PersonIcon from '@mui/icons-material/Person';
import { AccessibilityNewRounded } from '@mui/icons-material';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import StyledAutocomplete from "../../../components/UIComponents/StyledAutocomplete";
import { fetchRoomTypes, fetchRoomNo, getReportData, CreateCustomer, CreateCustomerAddress, CreateCustomerContact, getStatesByCountry, fetchCountryList, fetchStateList } from "../../../service/network";
import { useLoading } from "../../../context/loading.context";
import { useNotification } from "../../../context/notification.context";
import StyledTextField from "../../../components/UIComponents/StyledTextField";
import adultIcon from "../../../assets/icons/adult.png"
import childIcon from "../../../assets/icons/child.png"
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';

const DateBox = ({ date, day, month, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      width: 96,
      borderRadius: theme.borderRadius.medium,
      overflow: "hidden",
      cursor: "pointer",
      border: `2px solid ${theme.palette.primary.main}`
    }}
  >
    <Box
      sx={{
        backgroundColor: "primary.main",
        color: "light.main",
        py: 0.5,
        textAlign: "center"
      }}
    >
      <Typography variant="buttonL">{month}</Typography>
    </Box>
    <Box
      sx={{
        backgroundColor: "lightgray.main",
        color: "dark.main",
        textAlign: "center",
        py: 1
      }}
    >
      <Box>
        <Typography variant="title" display="block" textAlign="center">
          {date}
        </Typography>
        <Typography variant="subHeading" display="block" textAlign="center">
          {day}
        </Typography>
      </Box>
    </Box>
  </Box>
);

const titles = ["Website", "Phone", "Agent", "Walk-In"];
const types = ["Company", "Individual"];
const companies = ["ABC Corp", "XYZ Ltd", "Acme Inc", "Globex Corporation"];
const addressTypes = ["Billing", "Shipping", "Office", "Home"];

export default function ReservationDetails({ reservation, onChange, onSubmit, isEditMode }) {
  const [openDateDialog, setOpenDateDialog] = React.useState(false);
  const [openCorporateDialog, setOpenCorporateDialog] = React.useState(false);
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isMd = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const [roomTypeOptions, setRoomTypeOptions] = useState([]);
  const { showLoader, hideLoader } = useLoading();
  const [allRooms, setAllRooms] = useState([]);
  const { showNotification } = useNotification();
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [showCompanyField, setShowCompanyField] = useState(false);
  const [packages, setpackages] = useState([]);
  const isDisabled = reservation?.status === "Cancelled";
  const [corporates, setCorporates] = useState([]);
  const [formValues, setFormValues] = React.useState({
    checkInDate: dayjs(),
    checkOutDate: dayjs().add(1, 'day')
  });

  const [corporateForm, setCorporateForm] = React.useState({
    companyName: "",
    gstNo: "",
    addressType: "Billing",
    addressLine1: "",
    addressLine2: "",
    cityTown: "",
    state: "",
    country: "", // Changed from hardcoded India to empty
    postalCode: "",
    phone: ""
  });

  const [corporateFormErrors, setCorporateFormErrors] = React.useState({
    companyName: "",
    gstNo: "",
    phone: "",
    addressLine1: "",
    cityTown: "",
    state: "",
    country: "", // Added country validation
    postalCode: ""
  });

  const [selPackage, setSelPackage] = useState(null);
  const [selCorporate, setSelCorporate] = useState(null);
  const navigate = useNavigate();

  // Fetch countries on component mount
  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    try {
      showLoader(true);
      const Params = {
        doctype: "Country",
        fields: JSON.stringify(["country_name"]),
      };

      const response = await fetchCountryList(Params);

      if (response?.data?.message?.values) {
        const transformedCountries = response.data.message.values.map(
          ([country_name]) => ({
            name: country_name,
          })
        );
        setCountries(transformedCountries);
      } else {
        setCountries([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      showNotification("error", "Error", "Failed to fetch countries");
      setCountries([]);
    } finally {
      hideLoader();
    }
  };


// CORRECTED - Use the proper API call
const fetchStates = async (countryName) => {
  if (!countryName) {
    setStates([]);
    return;
  }

  try {
    showLoader(true);
    // Use the countriesnow.space API directly
    const response = await fetchStateList(countryName);
    
    if (response?.data?.data?.states) {
      const stateList = response.data.data.states.map(state => state.name);
      setStates(stateList);
    } else {
      setStates([]);
    }
  } catch (error) {
    console.error("Error fetching states:", error);
    showNotification("error", "Error", "Failed to fetch states");
    setStates([]);
  } finally {
    hideLoader();
  }
};
  // Corporate popup handlers
  const handleOpenCorporateDialog = () => {
    setOpenCorporateDialog(true);
  };

  const handleCloseCorporateDialog = () => {
    setOpenCorporateDialog(false);
    // Reset form when dialog closes
    setCorporateForm({
      companyName: "",
      gstNo: "",
      addressType: "Billing",
      addressLine1: "",
      addressLine2: "",
      cityTown: "",
      state: "",
      country: "",
      postalCode: "",
      phone: ""
    });
    setCorporateFormErrors({
      companyName: "",
      gstNo: "",
      phone: "",
      addressLine1: "",
      cityTown: "",
      state: "",
      country: "",
      postalCode: ""
    });
    setStates([]); // Clear states when dialog closes
  };

  const handleCorporateFormChange = (field, value) => {
    setCorporateForm(prev => ({
      ...prev,
      [field]: value
    }));

    // Clear error when user starts typing
    if (corporateFormErrors[field]) {
      setCorporateFormErrors(prev => ({
        ...prev,
        [field]: ""
      }));
    }

    // When country changes, fetch states and clear state field
    if (field === "country" && value) {
      fetchStates(value);
      setCorporateForm(prev => ({
        ...prev,
        state: "" // Clear state when country changes
      }));
    }
  };

  const validateCorporateForm = () => {
    const newErrors = {};

    if (!corporateForm.companyName || corporateForm.companyName.trim() === "") {
      newErrors.companyName = "Company name is required";
    }

    if (!corporateForm.gstNo || corporateForm.gstNo.trim() === "") {
      newErrors.gstNo = "GST number is required";
    }

    // Phone validation
    if (corporateForm.phone && corporateForm.phone.trim() !== "") {
      const phonePattern = /^[0-9]{10}$/;
      if (!phonePattern.test(corporateForm.phone)) {
        newErrors.phone = "Please enter a valid 10-digit phone number";
      }
    }

    // Address validation
    if (!corporateForm.addressLine1 || corporateForm.addressLine1.trim() === "") {
      newErrors.addressLine1 = "Address line 1 is required";
    }

    if (!corporateForm.country || corporateForm.country.trim() === "") {
      newErrors.country = "Country is required";
    }

    if (!corporateForm.state || corporateForm.state.trim() === "") {
      newErrors.state = "State is required";
    }

    if (!corporateForm.cityTown || corporateForm.cityTown.trim() === "") {
      newErrors.cityTown = "City/Town is required";
    }

    if (!corporateForm.postalCode || corporateForm.postalCode.trim() === "") {
      newErrors.postalCode = "Postal code is required";
    } else if (!/^\d{6}$/.test(corporateForm.postalCode)) {
      newErrors.postalCode = "Please enter a valid 6-digit postal code";
    }

    setCorporateFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
const handleSaveCorporate = async () => {
  if (!validateCorporateForm()) {
    showNotification('error', 'Validation Error', 'Please fix the errors before saving');
    return;
  }

  try {
    showLoader(true);

    let customerName = corporateForm.companyName;
    let customerResp = null;
    let addressResp = null;
    let contactResp = null;

    // Step 1: Check if customer already exists before creating
    try {
      const existingCustomers = await getReportData({
        doctype: "Customer",
        filters: [["customer_name", "=", customerName]],
        fields: ["name", "customer_name"]
      });

      if (existingCustomers.data.message?.values?.length > 0) {
        customerName = existingCustomers.data.message.values[0][0];
        showNotification('warning', 'Customer Exists', 'Using existing customer record');
      } else {
        const customerPayload = {
          data: {
            customer_name: customerName,
            customer_type: "Company",
            customer_group: "Commercial",
            tax_id: corporateForm.gstNo,
            country: corporateForm.country,
            language: "en",
            doctype: "Customer"
          }
        };
        customerResp = await CreateCustomer(customerPayload);
        customerName = customerResp.data.data.name;
      }
    } catch (customerError) {
      if (customerError.response?.data?.exception?.includes('DuplicateEntryError')) {
        customerName = `${corporateForm.companyName}-${Date.now()}`;
        const customerPayload = {
          data: {
            customer_name: corporateForm.companyName,
            name: customerName,
            customer_type: "Company",
            customer_group: "Commercial",
            tax_id: corporateForm.gstNo,
            country: corporateForm.country,
            language: "en",
            doctype: "Customer"
          }
        };
        customerResp = await CreateCustomer(customerPayload);
        customerName = customerResp.data.data.name;
      } else {
        throw customerError;
      }
    }

    // Step 2: Create Customer Contact (with mandatory email_id)
    if (corporateForm.phone) {
      const contactPayload = {
        data: {
          first_name: corporateForm.companyName,
          email_ids: [
            {
              email_id: corporateForm.email || `${customerName.toLowerCase()}@example.com`, // ✅ FIX
              is_primary: 1,
              doctype: "Contact Email"
            }
          ],
          phone_nos: [
            {
              phone: corporateForm.phone,
              is_primary_phone: 1,
              is_primary_mobile_no: 1,
              doctype: "Contact Phone"
            }
          ],
          links: [
            {
              link_doctype: "Customer",
              link_name: customerName,
              link_title: corporateForm.companyName,
              doctype: "Dynamic Link"
            }
          ],
          doctype: "Contact"
        }
      };

      try {
        contactResp = await CreateCustomerContact(contactPayload);
      } catch (contactError) {
        console.warn("Contact creation failed, continuing without contact:", contactError);
      }
    }

    // Step 3: Create Customer Address
    const addressTitle = `${corporateForm.companyName}-${corporateForm.addressType}`;
    const addressPayload = {
      data: {
        address_title: addressTitle,
        address_type: corporateForm.addressType,
        address_line1: corporateForm.addressLine1,
        address_line2: corporateForm.addressLine2 || "",
        city: corporateForm.cityTown,
        state: corporateForm.state,
        country: corporateForm.country,
        pincode: corporateForm.postalCode,
        links: [
          {
            link_doctype: "Customer",
            link_name: customerName,
            link_title: corporateForm.companyName,
            doctype: "Dynamic Link"
          }
        ],
        doctype: "Address"
      }
    };

    try {
      addressResp = await CreateCustomerAddress(addressPayload);
    } catch (addressError) {
      console.error("Address creation failed:", addressError);
      throw new Error("Failed to create address");
    }

    // Step 4: Update Customer with primary address/contact
    if (customerName && addressResp) {
      const updateCustomerPayload = {
        data: {
          customer_primary_address: addressResp.data.data.name,
          ...(contactResp && { customer_primary_contact: contactResp.data.data.name }),
          doctype: "Customer"
        }
      };

      try {
        // ✅ Use Update API instead of CreateCustomer (POST)
        await UpdateCustomer(customerName, updateCustomerPayload);
      } catch (updateError) {
        console.warn("Customer update failed, but customer was created:", updateError);
      }
    }

    // Success
    showNotification('success', 'Success', 'Corporate company details saved successfully');

    const newCorporate = {
      label: corporateForm.companyName,
      value: customerName
    };
    setCorporates(prev => [...prev, newCorporate]);
    setSelCorporate(newCorporate);
    onChange("corporate", customerName);
    handleCloseCorporateDialog();

  } catch (error) {
    console.error("Error saving corporate details:", error);
    let errorMessage = error.response?.data?.message || error.message || "Failed to save corporate details";
    showNotification('error', 'Error', errorMessage);
  } finally {
    hideLoader();
  }
};

// Add this useEffect to filter packages when room type changes
useEffect(() => {
  const filterPackagesByRoomType = async () => {
    if (!reservation.room_type) {
      // If no room type selected, show all active packages
      await fetchAllPackages();
      return;
    }

    try {
      showLoader(true);
      
      // Fetch all active packages with their details
      const packagesResponse = await getReportData({
        doctype: "Room Package",
        filters: [["status", "=", "Active"]],
        fields: ["package_name", "name", "package_details.room_type"]
      });

      let filteredPackages = [];
      
      if (packagesResponse.data.message && !Array.isArray(packagesResponse.data.message)) {
        const packagesData = packagesResponse.data.message.values;
        
        // Filter packages that have the selected room type in their package_details
        for (let pkg of packagesData) {
          const [packageName, packageId, roomTypes] = pkg;
          
          // roomTypes will be a string like "Deluxe,Suite" or just "Deluxe"
          if (roomTypes) {
            const roomTypeArray = roomTypes.split(',').map(rt => rt.trim());
            if (roomTypeArray.includes(reservation.room_type)) {
              filteredPackages.push({
                label: packageName,
                value: packageId
              });
            }
          }
        }
      }

      setpackages(filteredPackages);
      
      // Update selected package if it's still in the filtered list
      if (reservation.package) {
        const currentPackage = filteredPackages.find(p => p.value === reservation.package);
        setSelPackage(currentPackage || null);
      } else {
        setSelPackage(null);
      }
      
    } catch (err) {
      console.log("Error filtering packages by room type:", err);
      showNotification('error', 'Error', 'Failed to filter packages');
      // Fallback to showing all packages if filtering fails
      await fetchAllPackages();
    } finally {
      hideLoader();
    }
  };

  filterPackagesByRoomType();
}, [reservation.room_type]);

// Update fetchAllPackages function
const fetchAllPackages = async () => {
  try {
    let details = await getReportData({
      doctype: "Room Package",
      filters: [["status", "=", "Active"]],
      fields: ["package_name", "name"]
    });
    
    let temp = [];
    if (details.data.message && (!Array.isArray(details.data.message))) {
      for (let pck of details.data.message.values) {
        temp.push({
          label: pck[0],
          value: pck[1]
        });
      }
    }
    setpackages(temp);
    
    // Set selected package if it exists in the full list
    if (reservation.package) {
      const currentPackage = temp.find(p => p.value === reservation.package);
      setSelPackage(currentPackage || null);
    }
  } catch (err) {
    console.log("Error fetching all packages:", err);
    showNotification('error', 'Error', 'Failed to fetch packages');
    setpackages([]);
  }
};


// Replace your existing fetchPackagesList with fetchAllPackages
useEffect(() => {
  fetchAllPackages();
}, []);



// Also clear packages when component mounts initially without room type
useEffect(() => {
  if (!reservation.room_type) {
    fetchAllPackages();
  }
}, []);
  const fetchPackagesList = async () => {
    try {
      let details = await getReportData({
        doctype: "Room Package",
        filters: [["status", "=", "Active"]],
        fields: ["package_name", "name"]
      });
      let temp = [];
      if (details.data.message && (!Array.isArray(details.data.message))) {
        for (let pck of details.data.message.values) {
          temp.push({
            label: pck[0],
            value: pck[1]
          });
          console.log("Checking package", (reservation.package === pck[1]), reservation.package, pck[1]);
          if (reservation.package === pck[1]) {
            setSelPackage({
              label: pck[0],
              value: pck[1]
            });
          }
        }
      }
      setpackages(temp);
    } catch (err) {
      console.log(err);
    }
  }

  const fetchCorporateCustomers = async () => {
    try {
      let details = await getReportData({
        doctype: "Customer",
        filters: [["customer_type", "=", "Company"]],
        fields: ["customer_name", "name"]
      });
      let temp = [];
      if (details.data.message && (!Array.isArray(details.data.message))) {
        for (let pck of details.data.message.values) {
          temp.push({
            label: pck[0],
            value: pck[1]
          });
        }
      }
      setCorporates(temp);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (reservation.package !== selPackage?.value) {
      if (reservation.package) {
        for (let cd of packages) {
          if (cd.value === reservation.package) {
            setSelPackage(cd);
          }
        }
      } else {
        setSelPackage(null);
      }
    }
  }, [reservation.package]);

  useEffect(() => {
    if (reservation.corporate !== selCorporate?.value) {
      if (reservation.corporate) {
        for (let cd of corporates) {
          if (cd.value === reservation.corporate) {
            setSelCorporate(cd);
          }
        }
      } else {
        setSelCorporate(null);
      }
    }
  }, [reservation.corporate, corporates]);

  useEffect(() => {
    fetchPackagesList();
  }, []);

  useEffect(() => {
    fetchCorporateCustomers();
  }, []);

  useEffect(() => {
    console.log("Selecting package", selPackage);
    onChange("package", selPackage?.value || null);
  }, [selPackage]);

  useEffect(() => {
    console.log("Selecting corporate", selCorporate);
    onChange("corporate", selCorporate?.value || null);
  }, [selCorporate]);

  const handleChange = (field, value) => {
    if (isDisabled) return;
    if (field === "roomType") {
      onChange("room_type", value || "");
      if (!value) {
        onChange("room", ""); // clear room when room_type cleared
      }
      return;
    }

    if (field === "room") {
      if (value) {
        onChange("room", value.name);
        onChange("room_type", value.type);
      } else {
        onChange("room", "");
        onChange("room_type", ""); // clear room_type when room cleared
      }
      return;
    }

    if (field === "type") {
      setShowCompanyField(value === "Company");
      onChange(field, value);
      return;
    }

    onChange(field, value);
  };

  const openDatePicker = () => {
    setTempDates({
      checkIn: formValues.checkInDate,
      checkOut: formValues.checkOutDate
    });
    setOpenDateDialog(true);
  };

  const handleTempDateChange = (date, type) => {
    setTempDates(prev => ({ ...prev, [type]: date }));
  };

  const [tempDates, setTempDates] = React.useState({
    checkIn: reservation.from_date ? dayjs(reservation.from_date) : dayjs(),
    checkOut: reservation.to_date ? dayjs(reservation.to_date) : dayjs().add(1, 'day')
  });

  const applyDateChanges = () => {
    let checkIn = tempDates.checkIn;
    let checkOut = tempDates.checkOut;

    if (checkOut.isSame(checkIn) || checkOut.isBefore(checkIn)) {
      checkOut = checkIn.add(1, 'day');
    }

    onChange("from_date", checkIn.format("YYYY-MM-DD"));
    onChange("to_date", checkOut.format("YYYY-MM-DD"));
    setOpenDateDialog(false);
  };

  React.useEffect(() => {
    if (openDateDialog) {
      setTempDates({
        checkIn: reservation.from_date ? dayjs(reservation.from_date) : dayjs(),
        checkOut: reservation.to_date ? dayjs(reservation.to_date) : dayjs().add(1, 'day')
      });
    }
  }, [openDateDialog, reservation]);

  const calculateNights = () => {
    if (!reservation.from_date || !reservation.to_date) return 0;
    return dayjs(reservation.to_date).diff(dayjs(reservation.from_date), 'day');
  };

  const formatDate = (date) => {
    return {
      date: date.date(),
      day: date.format('dddd').substring(0, 3),
      month: date.format('MMM YYYY')
    };
  };

  const checkInFormatted = formatDate(reservation.from_date ? dayjs(reservation.from_date) : dayjs());
  const checkOutFormatted = formatDate(reservation.to_date ? dayjs(reservation.to_date) : dayjs().add(1, 'day'));

  const fetchRoomNumber = async () => {
    try {
      showLoader(true);
      const Params = {
        doctype: 'Room',
        fields: JSON.stringify(["name", "room_name", "type", "status"])
      };

      const response = await fetchRoomNo(Params);

      if (response.data && response.data.message && response.data.message.values) {
        const transformedRooms = response.data.message.values.map(([name, room_name, type, status]) => ({
          name: name,
          room_name: room_name,
          type: type,
          status: status
        }));

        setAllRooms(transformedRooms);
      } else {
        showNotification('error', 'Error', 'Failed to fetch room data');
      }
    } catch (error) {
      console.error('Error fetching room numbers:', error);
      showNotification('error', 'Error', 'Failed to fetch room numbers');
    } finally {
      hideLoader();
    }
  };

  const fetchRoomTypesList = async () => {
    try {
      showLoader();
      const roomTypeParams = {
        doctype: 'Room Type',
        fields: JSON.stringify(["name", "room_type"])
      };
      const roomTypeRes = await fetchRoomTypes(roomTypeParams);

      if (roomTypeRes.data && roomTypeRes.data.message && roomTypeRes.data.message.values) {
        const roomTypes = roomTypeRes.data.message.values.map(item => item[1]);
        setRoomTypeOptions([...new Set(roomTypes)]);
      } else {
        showNotification('error', 'Error', 'Failed to fetch room types');
      }
    } catch (err) {
      console.error("Failed to fetch room types", err);
      showNotification('error', 'Error', 'Failed to fetch room types');
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchRoomTypesList();
    fetchRoomNumber();
  }, []);

  useEffect(() => {
    if (reservation.room_type) {
      const filtered = allRooms.filter(
        room => room.type === reservation.room_type
      );
      setFilteredRooms(filtered);
    } else {
      setFilteredRooms([]);
    }
  }, [reservation.room_type, allRooms]);

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await onSubmit();
    } catch (error) {
      console.error("Error submitting reservation:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Checked-In':
        return theme.palette.green.main;
      case 'Checked-Out':
        return theme.palette.red.main;
      case 'Booked':
        return theme.palette.blue.main;
      case 'Cancelled':
        return theme.palette.grey.main;
      case 'Completed':
        return theme.palette.primary.main;
      default:
        return theme.palette.text.primary;
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{
        minHeight: "100vh",
        backgroundColor: theme.palette.light.main,
      }}>
        <Box
          sx={{
            backgroundColor: theme.palette.light.main,
            borderRadius: theme.borderRadius.xl,
            maxWidth: 600,
            p: 2,
            boxShadow: theme.shadows[3],
            mx: 'auto'
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="SubTitleBold" sx={{ color: theme.palette.dark.main }}>
              Reservation Details
            </Typography>
          </Box>

          {/* Date Selection */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            mb: 2,
            mt: 2,
            flexWrap: 'wrap'
          }}>
            <DateBox {...checkInFormatted} onClick={openDatePicker} />

            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              minWidth: 90,
              order: isXs ? 2 : 0,
              width: isXs ? '100%' : 'auto',
              mt: isXs ? 2 : 0
            }}>
              <Typography variant="bodyText1" sx={{
                mb: 1,
                color: "dark.main",
                border: "1px solid var(--Gray, #CFCFCF)",
                padding: "4px 8px",
                borderRadius: "4px",
                display: "inline-block",
                cursor: "default"
              }}>
                {calculateNights()} Nights
              </Typography>
              <Box
                component="img"
                src={ArrowCircle_img}
                sx={{ width: 80, height: 8 }}
              />
            </Box>

            <DateBox {...checkOutFormatted} onClick={openDatePicker} />
          </Box>

          {/* Date Picker Dialog */}
          <Dialog
            open={openDateDialog}
            onClose={() => setOpenDateDialog(false)}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                backgroundColor: theme.palette.light.main,
                borderRadius: theme.borderRadius.medium,
              },
            }}
          >
            <DialogTitle>Select Check-in & Check-out Dates</DialogTitle>
            <DialogContent>
              <Grid container spacing={1}>
                <Grid size={6}>
                  <Typography variant="bodyText1" mb={1}>Check-In</Typography>
                  <DateCalendar
                    value={tempDates.checkIn}
                    onChange={(newValue) => handleTempDateChange(newValue, 'checkIn')}
                  />
                </Grid>

                <Grid size={6}>
                  <Typography variant="bodyText1" mb={1}>Check-Out</Typography>
                  <DateCalendar
                    value={tempDates.checkOut}
                    onChange={(newValue) => handleTempDateChange(newValue, 'checkOut')}
                    minDate={tempDates.checkIn}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions sx={{ gap: 3, px: 3, pb: 2 }}>
              <Button
                onClick={() => setOpenDateDialog(false)}
                variant="outlined"
                sx={{
                  borderRadius: theme.borderRadius.medium,
                  borderColor: theme.palette.border,
                  color: theme.palette.primary.main,
                  backgroundColor: theme.palette.light.main,
                  px: 4,
                  "&:hover": {
                    borderColor: theme.palette.green.main,
                  },
                }}
              >
                Cancel
              </Button>

              <Button
                onClick={applyDateChanges}
                variant="contained"
                sx={{
                  borderRadius: theme.borderRadius.medium,
                  backgroundColor: theme.palette.green.main,
                  color: theme.palette.light.main,
                  px: 4,
                }}
              >
                Apply
              </Button>
            </DialogActions>
          </Dialog>

          {/* Guest Count */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            mb: 2,
            flexWrap: 'wrap',
            width: '100%'
          }}>
            {/* Adults Field */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flex: isXs ? '0 0 100%' : '0 0 auto',
                maxWidth: isXs ? '100%' : '200px',
                width: isXs ? '100%' : 'auto',
                gap: 1.2
              }}
            >
              <img src={adultIcon} width={22} alt="Adults" />

              <Autocomplete
                disabled={isDisabled}
                size="small"
                options={[1, 2, 3, 4, 5, 6]}
                value={Number(reservation.no_of_adult) || 1}
                onChange={(e, v) => handleChange('no_of_adult', Number(v) || 1)}
                getOptionLabel={(option) => option.toString()}
                disableClearable
                sx={{
                  width: isXs ? '100%' : '100px',
                  '& .MuiOutlinedInput-root': {
                    height: 40,
                    borderRadius: 2
                  },
                  '& .MuiAutocomplete-inputRoot': {
                    paddingRight: '14px !important'
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: 40,
                        borderRadius: 2
                      }
                    }}
                  />
                )}
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flex: isXs ? '0 0 100%' : '0 0 auto',
                maxWidth: isXs ? '100%' : '200px',
                width: isXs ? '100%' : 'auto',
                gap: 1.2
              }}
            >
              <img src={childIcon} width={22} alt="Children" />
              <Autocomplete
                size="small"
                disabled={isDisabled}
                options={[0, 1, 2, 3, 4]}
                value={Number(reservation.no_of_child) || 0}
                onChange={(e, v) => handleChange('no_of_child', Number(v) || 0)}
                getOptionLabel={(option) => option.toString()}
                disableClearable
                sx={{
                  width: isXs ? '100%' : '100px',
                  '& .MuiOutlinedInput-root': {
                    height: 36,
                    borderRadius: 2,
                  },
                  '& .MuiAutocomplete-inputRoot': {
                    paddingRight: '14px !important',
                  },
                }}
                slotProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option:hover': {
                        backgroundColor: '#e3f2fd',
                      },
                    },
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: 36,
                        borderRadius: 2,
                      },
                    }}
                  />
                )}
              />
            </Box>
          </Box>

          {/* Room Selection */}
          <Grid container spacing={1}>
            <Grid size={6}>
              <FormControl fullWidth>
                <StyledAutocomplete
                  disabled={isDisabled}
                  label="Room Type"
                  placeholder="Select"
                  disableClearable
                  options={roomTypeOptions}
                  getOptionLabel={(option) => option?.toString() || ""}
                  value={reservation.room_type || null}
                  onChange={(e, value) => handleChange("roomType", value)}
                  isOptionEqualToValue={(option, value) => option === value}
                />
              </FormControl>
            </Grid>

            <Grid size={6}>
              <StyledAutocomplete
                disabled={isDisabled}
                label="Room No"
                placeholder="Select"
                disableClearable
                options={filteredRooms}
                getOptionLabel={(option) => option?.room_name?.toString() || ""}
                value={
                  filteredRooms.find(r => r.name === reservation.room) || null
                }
                onChange={(e, value) => handleChange("room", value)}
                isOptionEqualToValue={(option, value) => option?.name === value?.name}
                renderOption={(props, option) => (
                  <li {...props} key={option.name}>
                    {option.room_name}
                  </li>
                )}
              />
            </Grid>

            <Grid size={12}>
              <StyledTextField
                fullWidth
                placeholder="Enter purpose of visit"
                value={reservation.purpose}
                onChange={(e) => handleChange("purpose", e.target.value)}
                label="Purpose"
                disabled={isDisabled}
              />
            </Grid>

            <Grid size={12}>
              <StyledAutocomplete
                label="Booking Source"
                placeholder="Select"
                options={titles}
                value={reservation.booking_source}
                onChange={(e, value) => handleChange("booking_source", value)}
                disabled={isDisabled}
              />
            </Grid>

            <Grid size={12}>
              <StyledAutocomplete
                disabled={isDisabled}
                options={types}
                disableClearable
                label="Reservation Type"
                placeholder="Select"
                value={reservation.type}
                onChange={(e, value) => handleChange("type", value)}
              />
            </Grid>

            {/* Conditionally render company field */}
            {(reservation.type === "Company") && (
              <Grid size={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <StyledAutocomplete
                    options={corporates}
                    label="Corporate"
                    placeholder="Select Corporate"
                    value={selCorporate}
                    onChange={(e, value) => setSelCorporate(value)}
                    sx={{ flex: 1 }}
                  />
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={handleOpenCorporateDialog}
                    sx={{
                      height: 30,
                      mt: 3.5,
                      borderRadius: 2,
                      borderColor: theme.palette.gray.main,
                      color: theme.palette.dark.main,
                    }}
                  >
                    New
                  </Button>
                </Box>
              </Grid>
            )}

            <Grid size={12}>
              <Box sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 3,
                flexWrap: 'wrap'
              }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/list/reservation')}
                  sx={{
                    width: 130,
                    height: 36,
                    borderRadius: theme.borderRadius.medium,
                    borderColor: theme.palette.gray.main,
                    color: theme.palette.dark.main,
                    py: 1.5,
                    "&:hover": {
                      borderColor: theme.palette.green.main
                    }
                  }}
                >
                  Cancel
                </Button>
                {reservation?.status !== "Cancelled" && (
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    sx={{
                      borderRadius: theme.borderRadius.medium,
                      backgroundColor: theme.palette.green.main,
                      color: theme.palette.light.main,
                      py: 1.5,
                      width: 130,
                      height: 36,
                      "&:hover": {
                        backgroundColor: theme.palette.green.dark
                      },
                      "&:disabled": {
                        backgroundColor: theme.palette.gray.main,
                        color: theme.palette.dark.main
                      }
                    }}
                  >
                    {isSubmitting ? 'Processing...' : isEditMode ? 'Update' : 'Reserve'}
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Corporate Details Dialog */}
        <Dialog
          open={openCorporateDialog}
          onClose={handleCloseCorporateDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: theme.palette.light.main,
              borderRadius: theme.borderRadius.medium,
            },
          }}
        >
          <DialogTitle>Add Corporate Company Details</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid size={6}>
                <StyledTextField
                  fullWidth
                  label="Company Name"
                  placeholder="Company Name"
                  value={corporateForm.companyName}
                  onChange={(e) => handleCorporateFormChange("companyName", e.target.value)}
                  error={!!corporateFormErrors.companyName}
                  helperText={corporateFormErrors.companyName}
                  required
                />
              </Grid>
              <Grid size={6}>
                <StyledTextField
                  fullWidth
                  label="GST No"
                  placeholder="GST No"
                  value={corporateForm.gstNo}
                  onChange={(e) => handleCorporateFormChange("gstNo", e.target.value)}
                  error={!!corporateFormErrors.gstNo}
                  helperText={corporateFormErrors.gstNo}
                  required
                />
              </Grid>

              <Grid size={12}>
                <Typography variant="subtitle1" sx={{ mb: 1, color: theme.palette.dark.main }}>
                  Billing Address Details
                </Typography>
              </Grid>

              <Grid size={6}>
                <StyledTextField
                  fullWidth
                  label="Phone"
                  placeholder="+91"
                  value={corporateForm.phone}
                  onChange={(e) => handleCorporateFormChange("phone", e.target.value)}
                  error={!!corporateFormErrors.phone}
                  helperText={corporateFormErrors.phone}
                />
              </Grid>
              <Grid size={6}>
                <StyledAutocomplete
                  fullWidth
                  label="Country"
                  placeholder="Select Country"
                  options={countries.map(c => c.name)} // since we stored as { name }
                  value={corporateForm.country}
                  onChange={(e, value) => {
                    handleCorporateFormChange("country", value);
                    fetchStates(value); // trigger states when country changes
                  }}
                  error={!!corporateFormErrors.country}
                  helperText={corporateFormErrors.country}
                  required
                />

              </Grid>

              <Grid size={8}>
                <StyledTextField
                  fullWidth
                  label="Address Line 1"
                  placeholder="Enter Address"
                  value={corporateForm.addressLine1}
                  onChange={(e) => handleCorporateFormChange("addressLine1", e.target.value)}
                  error={!!corporateFormErrors.addressLine1}
                  helperText={corporateFormErrors.addressLine1}
                  required
                />
              </Grid>
              <Grid size={4}>
                <StyledTextField
                  fullWidth
                  label="Address Line 2"
                  placeholder="Enter Address (Optional)"
                  value={corporateForm.addressLine2}
                  onChange={(e) => handleCorporateFormChange("addressLine2", e.target.value)}
                />
              </Grid>

              <Grid size={4}>
                <StyledAutocomplete
                  fullWidth
                  label="State"
                  placeholder="Select State"
                  options={states}
                  value={corporateForm.state}
                  onChange={(e, value) => handleCorporateFormChange("state", value)}
                  disabled={!corporateForm.country}
                  error={!!corporateFormErrors.state}
                  helperText={corporateFormErrors.state}
                  required
                />

              </Grid>

              <Grid size={4}>
                <StyledTextField
                  fullWidth
                  label="City/Town"
                  placeholder="Enter City/Town"
                  value={corporateForm.cityTown}
                  onChange={(e) => handleCorporateFormChange("cityTown", e.target.value)}
                  error={!!corporateFormErrors.cityTown}
                  helperText={corporateFormErrors.cityTown}
                  required
                />
              </Grid>



              <Grid size={4}>
                <StyledTextField
                  fullWidth
                  label="Postal Code"
                  placeholder="Enter Postal Code"
                  value={corporateForm.postalCode}
                  onChange={(e) => handleCorporateFormChange("postalCode", e.target.value)}
                  error={!!corporateFormErrors.postalCode}
                  helperText={corporateFormErrors.postalCode}
                  required
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ gap: 3, px: 3, pb: 2 }}>
            <Button
              onClick={handleCloseCorporateDialog}
              variant="outlined"
              sx={{
                borderRadius: theme.borderRadius.medium,
                borderColor: theme.palette.border,
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.light.main,
                px: 4,
                "&:hover": {
                  borderColor: theme.palette.green.main,
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSaveCorporate}
              variant="contained"
              sx={{
                borderRadius: theme.borderRadius.medium,
                backgroundColor: theme.palette.green.main,
                color: theme.palette.light.main,
                px: 4,
              }}
            >
              Save Corporate
            </Button>
          </DialogActions>
        </Dialog>

        {/* Rate/Packages Section */}
        <Box sx={{
          backgroundColor: theme.palette.light.main,
          borderRadius: theme.borderRadius.xl,
          p: 2.5,
          mt: 2,
          boxShadow: theme.shadows[3],
          maxWidth: 600,
          mx: 'auto'
        }}>
          <Typography variant="SubTitleBold" gutterBottom sx={{ color: theme.palette.dark.main }}>
            Rate/Packages&nbsp;
            <Typography variant="bodyText1" component="span">
              (For {calculateNights()} Nights)
            </Typography>
          </Typography>
          <Grid container spacing={1}>
            <Grid size={12}>
              <StyledAutocomplete
                label="Packages"
                options={packages}
                value={selPackage}
                onChange={(e, value) => setSelPackage(value)}
              />
            </Grid>
            <Grid
              container
              justifyContent="flex-end"
              sx={{ mt: 3 }}
            >
            </Grid>
          </Grid>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}